import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import ButtonComponent from './ButtonComponent';
import '../styles/zoomControlButton.scss';
import globalStore from '../store';
import { useOnResize } from '../helper/hooks/onResize';
import { WHITEBOARD_ZOOM_LEVELS, ICON_ZOOM_LEVELS, nextZoomLevel, prevZoomLevel, } from '../constants/zoomConstants';
var zoomIn = {
    normal: './assets/images/icons/zoomInN.png',
    hover: './assets/images/icons/zoomInH.png',
    disable: './assets/images/icons/zoomInD.png',
};
var zoomOut = {
    normal: './assets/images/icons/zoomOutN.png',
    hover: './assets/images/icons/zoomOutH.png',
    disable: './assets/images/icons/zoomOutD.png',
};
var getSizes = function (orientation) {
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    // header height ratio ~ 0.0648 of viewport (1920*1080)
    var zoomHeightRatio = orientation === 'vertical' ? 0.1296 : 0.05092;
    var zoomWidthRatio = orientation === 'vertical' ? 0.0286 : 0.0729;
    // if (vw <= 768 && orientation === 'vertical') {
    //   zoomWidthRatio = 0.039;
    // }
    var valueFactorHeight = Math.round(vh * zoomHeightRatio);
    var valueFactorWidth = Math.round(vw * zoomWidthRatio);
    var zoomHeight = Math.max(valueFactorHeight, 25);
    var zoomWidth = Math.max(valueFactorWidth, 25);
    // button sizing logic: use min of width/height scaled values (keeps buttons square)
    var zoomBtnHeightRatio = 0.046;
    var zoomBtnWidthRatio = 0.026;
    // if (vw <= 768 && orientation === 'vertical') {
    //   zoomBtnWidthRatio = 0.05;
    // }
    var buttonWidth = Math.round(vw * zoomBtnWidthRatio);
    var buttonHeight = Math.round(vh * zoomBtnHeightRatio);
    var btnSize = Math.max(Math.min(buttonWidth, buttonHeight), 15);
    // ]
    return {
        zoomWidth: zoomWidth,
        zoomHeight: zoomHeight,
        btnWidth: btnSize,
        btnHeight: btnSize,
    };
};
var ZoomControlButton = function (props) {
    var _a = props.orientation, orientation = _a === void 0 ? 'vertical' : _a, _b = props.className, className = _b === void 0 ? '' : _b, _c = props.isWhiteBoard, isWhiteBoard = _c === void 0 ? true : _c;
    // Access zoomLevel and action from global store (Easy Peasy)
    var _d = globalStore.useStoreState(function (state) { return state.playerStore; }), zoomLevel = _d.zoomLevel, playerIconZoom = _d.playerIconZoom, displayMode = _d.displayMode;
    var _e = globalStore.useStoreActions(function (state) { return state.playerStore; }), setUserZoom = _e.setUserZoom, setplayerIconZoom = _e.setplayerIconZoom;
    var btnConfig = globalStore.useStoreState(function (state) { return state.jsonDataStore; }).btnConfig;
    var zoomIn = btnConfig === null || btnConfig === void 0 ? void 0 : btnConfig.zoomIn;
    var zoomOut = btnConfig === null || btnConfig === void 0 ? void 0 : btnConfig.zoomOut;
    // compute initial sizes synchronously to prevent flicker on mount
    var initial = useMemo(function () { return getSizes(orientation); }, []);
    var _f = useState(function () { return initial; }), sizes = _f[0], setSizes = _f[1];
    // Shared with the Ctrl+= / Ctrl+- shortcuts in GameController — see
    // src/constants/zoomConstants.ts. The whiteboard ladder is 20%-200% in steps
    // of 10; the icon ladder is deliberately coarser and never below 1.
    var ZOOMLEVELS = isWhiteBoard ? WHITEBOARD_ZOOM_LEVELS : ICON_ZOOM_LEVELS;
    // Handler to zoom in: moves to next level if exists
    var changeZoomVariables = function () {
        var varArr = [
            '--font-size-1',
            '--font-size-2',
            '--font-size-3',
            '--tool-tip',
            '--radio-text-size',
        ];
        varArr.forEach(function (item) {
            var iconSize = getComputedStyle(document.documentElement).getPropertyValue(item);
            var icondimension = Number(iconSize.slice(0, 2));
            document.documentElement.style.setProperty("--zoomed".concat(item.substring(1)), "".concat(playerIconZoom * icondimension, "px"));
        });
    };
    useEffect(function () {
        changeZoomVariables();
    }, [playerIconZoom]);
    useOnResize(changeZoomVariables, 300);
    // useEffect(() => {
    //   const iconSize: string = getComputedStyle(document.documentElement).getPropertyValue(
    //     '--icon-size'
    //   );
    //   const icondimension: number = Number(iconSize.slice(0, 2));
    //   document.documentElement.style.setProperty(
    //     '--zoomed-icon-size',
    //     `${playerIconZoom * Number(icondimension)}px`
    //   );
    // }, [playerIconZoom]);
    // useEffect(() => {
    //   const fontSize1: string = getComputedStyle(document.documentElement).getPropertyValue(
    //     '--font-size-1'
    //   );
    //   const fontSize2: string = getComputedStyle(document.documentElement).getPropertyValue(
    //     '--font-size-2'
    //   );
    //   const toolTip: string = getComputedStyle(document.documentElement).getPropertyValue(
    //     '--tool-tip'
    //   );
    //   const fontSize1dimension: number = Number(fontSize1.slice(0, 2));
    //   const fontSize2dimension: number = Number(fontSize2.slice(0, 2));
    //   const toolTipdimension: number = Number(toolTip.slice(0, 2));
    //   document.documentElement.style.setProperty(
    //     '--zoomed-font-size-1',
    //     `${playerIconZoom * Number(fontSize1dimension)}px`
    //   );
    //   document.documentElement.style.setProperty(
    //     '--zoomed-font-size-2',
    //     `${playerIconZoom * Number(fontSize2dimension)}px`
    //   );
    //   document.documentElement.style.setProperty(
    //     '--zoomed-tool-tip',
    //     `${playerIconZoom * Number(toolTipdimension)}px`
    //   );
    // }, [playerIconZoom]);
    // Zoom in/out work against the current zoom value — not just exact matches
    // in ZOOMLEVELS. When the current zoom falls between steps (e.g. 0.36 from
    // fit-to-viewport), zoom-in picks the next level strictly greater, zoom-out
    // picks the largest level strictly less. No match ⇒ no-op.
    var current = isWhiteBoard ? zoomLevel : playerIconZoom;
    var onZoomIn = function () {
        var next = nextZoomLevel(ZOOMLEVELS, current);
        if (next === undefined)
            return;
        isWhiteBoard ? setUserZoom(next) : setplayerIconZoom(next);
    };
    var onZoomOut = function () {
        var prev = prevZoomLevel(ZOOMLEVELS, current);
        if (prev === undefined)
            return;
        isWhiteBoard ? setUserZoom(prev) : setplayerIconZoom(prev);
    };
    // Bound with <= / >= rather than an equality test. Zoom-to-fit sets an
    // arbitrary computed value and keeps its own 5% floor, so `current` can sit
    // BELOW the ladder's 20% minimum or ABOVE its 200% maximum (a canvas smaller
    // than the viewport fits at over 2x). An `=== last` test left the button
    // enabled in that case while the handler no-op'd, so it looked clickable and
    // did nothing.
    var atMinZoom = current <= ZOOMLEVELS[0];
    var atMaxZoom = current >= ZOOMLEVELS[ZOOMLEVELS.length - 1];
    // --------------------------------------------------------------------------------
    var computeSizes = useCallback(function () {
        setSizes(getSizes(orientation));
    }, [orientation]);
    // run before paint for synchronous update (no flicker)
    useLayoutEffect(function () {
        computeSizes();
    }, [computeSizes]);
    // keep responsive
    useOnResize(computeSizes);
    var currentZoomPercent = (current * 100).toFixed(0);
    return (_jsxs("div", { className: "zoomControlPanel ".concat(orientation, " ").concat(className), children: [_jsx("div", { ref: props.zoomOutRef, children: _jsx(ButtonComponent, { imgSrc: zoomOut === null || zoomOut === void 0 ? void 0 : zoomOut.imgSrc, title: zoomOut === null || zoomOut === void 0 ? void 0 : zoomOut.title, ariaLabel: zoomOut === null || zoomOut === void 0 ? void 0 : zoomOut.ariaLabel, defaultCSS: "zoomBtn", normalCSS: "zoomBtn", clickHandler: onZoomOut, disabled: atMinZoom, imgWidth: 24, showToolTip: true, direction: displayMode === 'normal' ? 'top' : 'bottom' }) }), _jsx("span", { className: "zoomControlLevel", role: "status", "aria-live": "polite", children: "".concat(currentZoomPercent, "%") }), _jsxs("div", { ref: props.zoomInRef, children: [' ', _jsx(ButtonComponent, { imgSrc: zoomIn === null || zoomIn === void 0 ? void 0 : zoomIn.imgSrc, title: zoomIn === null || zoomIn === void 0 ? void 0 : zoomIn.title, ariaLabel: zoomIn === null || zoomIn === void 0 ? void 0 : zoomIn.ariaLabel, defaultCSS: "zoomBtn", normalCSS: "zoomBtn", clickHandler: onZoomIn, disabled: atMaxZoom, imgWidth: 24, showToolTip: true, direction: displayMode === 'normal' ? 'top' : 'bottom' }), ' '] })] }));
};
export default ZoomControlButton;
